

 
 <div class="position-relative mb-2" *ngIf="!loadingSubmiting">
  <owl-carousel-o [options]="customOptions" *ngIf="adsList.length > 0">
    <ng-container >
        <ng-template carouselSlide *ngFor="let adsObj of adsList;trackBy: trackById">           
            <div class="slide">
              
                <img [attr.src]="adsObj.imageUrl" [alt]="adsObj.name" loading="lazy" class="img-fluid" width="450" height="160" fetchpriority="high"
  decoding="async">
            </div>
        </ng-template>  
    </ng-container>  
  </owl-carousel-o> 
  <div class="overlay" *ngIf ="marqueeText != null">
    <marquee direction="left"><h5>{{marqueeText.marqueeText}}</h5></marquee>
  </div>
 </div>
 
 <div class="p-5 slide__div" *ngIf="loadingSubmiting">
    <ngx-spinner size="small" color="rgb(255,255,255)"  bdColor="rgba(21, 134, 11, 0)"   type="ball-spin-clockwise"
      [fullScreen]="false"></ngx-spinner>
  </div>

 
  